import React, {useState} from 'react'
import {FaBars, FaTimes, FaGithub, FaTwitter, } from 'react-icons/fa'
import {SiLinkedin} from 'react-icons/si'  
import { HiOutlineMail} from 'react-icons/hi'
import logo from '../assets/Me.png'
import {Link} from 'react-scroll'
import GitHub from '../assets/github.png';
import Twitter from '../assets/twitter.png';



const Navbar = () => {

  
    const [nav, setNav] = useState(false)
    const handleClick = () => setNav(!nav)

  return (
    <div  className='fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#0a192f] text-gray-300'>
      
      <div>
        <img className='mt-1 ml-70'
        src={logo} alt="logo" style={{width:'70px'}}
         />
      </div>

        {/* Github  */}
      <div className='  flex mx-auto md:hidden '>
        <a href="https://github.com/Eren-17"><img className='mx-3  hover:scale-110 duration-500' src={GitHub} alt='github' style={{width:'30px'}}/></a>
      </div>

      {/* twitter  */}
      <div className='flex mr-20  mx-auto md:hidden'>
        <a href="https://twitter.com/shahidshaikh_10"><img className='mx-3  hover:scale-110 duration-500' src={Twitter} alt="" style={{width:'30px'}} /></a>
      </div>

      {/* MENU  */}
      <div>
        <ul className='hidden md:flex cursor-pointer items-center justify-items-center mt-7  text-lg'>
            <li className='hover:text-cyan-300'>
            <Link to="home" smooth={true} offset={50} duration={500} >
            Home
            </Link>  
            </li>

            <li className='hover:text-cyan-300'>
              <Link to="about" smooth={true}  duration={500} >
                About
              </Link>
            </li>

            <li className='hover:text-cyan-300'>
            <Link to="skills" smooth={true}  duration={500} >
             Skills
            </Link>  
            </li>
            <li className='hover:text-cyan-300'>
            <Link to="contact" smooth={true}  duration={500} >
             Contact
            </Link>
            </li>
        </ul>
      </div>
      {/* MENU  */} 

      {/* BURGER  */}
      <div onClick={handleClick} className='md:hidden z-10  items-stretch'>
      {!nav ? <FaBars/> : <FaTimes/>
}      </div>

      {/* Mobile  */}

      <ul className={!nav ?'hidden' : 'absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center className="py-6 text-3xl"'}>
            <li   className="py-6 text-3xl">
            <Link onClick={handleClick} to="home" smooth={true} offset={50} duration={500} >
            Home
            </Link>
            </li>

            <li className="py-6 text-3xl">
            <Link onClick={handleClick} to="about" smooth={true}  duration={500} >
            About
            </Link>
            </li>
            
            <li className="py-6 text-3xl">
            <Link onClick={handleClick} to="skills" smooth={true}  duration={500} >
             Skills
            </Link>
            </li>

            <li className="py-6 text-3xl">
            <Link onClick={handleClick} to="contact" smooth={true}  duration={500} >
             Contact
            </Link>
            </li>
      </ul>

      {/* ICONS  */}

      <div className='hidden md:flex fixed flex-col top-[35%] left-0'>
        <ul>
          <li className='w-[120px] h-[60] flex justify-between items-center ml-[-78px] hover:ml-[-10px] duration-300 bg-[#333333]'>
            <a className='flex justify-between items-center w-full text-gray-300 text-lg'
              href="https://github.com/Eren-17">
              GitHub <FaGithub className='ml-2'size={25}/>
            </a>
          </li>
          <li className='w-[120px] h-[60] flex justify-between items-center ml-[-78px] hover:ml-[-10px] duration-300 bg-blue-600'>
            <a className='flex justify-between items-center w-full text-gray-300 text-md'
              href="https://twitter.com/shahidshaikh_10">
              Twitter  <FaTwitter className='ml-1'size={25}/>
            </a>
          </li>
          <li className='w-[120px] h-[60] flex justify-between items-center ml-[-78px] hover:ml-[-11px] duration-300 bg-[#6fc2b0]'>
            <a className='flex justify-between items-center w-full text-gray-300 text-lg'
              href='mailto:shaikhshahid.10a@gmail.com'>
              Email <HiOutlineMail className='ml-2'size={25}/>
            </a>
          </li>
          <li className='w-[120px] h-[60] flex justify-between items-center ml-[-78px] hover:ml-[-10px] duration-300 bg-blue-700'>
            <a className='flex justify-between items-center w-full text-white text-md'
              href='https://www.linkedin.com/in/shahid-shaikh-b6496524b/'>
              LinkedIn   <SiLinkedin className='ml-1  h-10'size={25}/>
            </a>
          </li>
        </ul>

      </div>
    </div>
  )
}

export default Navbar
